export default function combinationsService($http, RESOURCES) {
  var areasSegment = '/areas',
    combinationsSegment = '/combinations';

  function getCombinations(merchantId, areaId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + areasSegment + '/' + areaId + combinationsSegment);
  }

  function updateCombinations(merchantId, areaId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + areasSegment + '/' + areaId + combinationsSegment, data);
  }

  function deleteCombination(merchantId, areaId, combinationId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + areasSegment + '/' + areaId + combinationsSegment + '/' + combinationId);
  }

  function deleteCombinations(merchantId, areaId, selectedCombinationIds) {
    var params = {
      params: {
        combinationIds: selectedCombinationIds,
      },
    };
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + areasSegment + '/' + areaId + combinationsSegment, params);
  }

  return {
    getCombinations: getCombinations,
    updateCombinations: updateCombinations,
    deleteCombination: deleteCombination,
    deleteCombinations: deleteCombinations,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/combinations/combinations.service.js